import * as React from "react";
import type { SVGProps } from "react";
const SvgInformation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M5.125 22.938A5.875 5.875 0 0 1 11 17.063h42a5.875 5.875 0 0 1 5.875 5.875v29h-1.75v-29A4.125 4.125 0 0 0 53 18.813H11a4.125 4.125 0 0 0-4.125 4.125v29h-1.75v-29ZM62.25 53.688H1.75v2.25c0 .69.56 1.25 1.25 1.25h58c.69 0 1.25-.56 1.25-1.25v-2.25ZM0 51.938v4a3 3 0 0 0 3 3h58a3 3 0 0 0 3-3v-4H0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M11 43.438a1.5 1.5 0 0 1 1.5-1.5h38a1.5 1.5 0 0 1 0 3h-38a1.5 1.5 0 0 1-1.5-1.5ZM11 48.438a1.5 1.5 0 0 1 1.5-1.5h38a1.5 1.5 0 0 1 0 3h-38a1.5 1.5 0 0 1-1.5-1.5ZM11 33.438a1.5 1.5 0 0 1 1.5-1.5h38a1.5 1.5 0 0 1 0 3h-38a1.5 1.5 0 0 1-1.5-1.5ZM11 23.438a1.5 1.5 0 0 1 1.5-1.5h38a1.5 1.5 0 0 1 0 3h-38a1.5 1.5 0 0 1-1.5-1.5ZM11 38.438a1.5 1.5 0 0 1 1.5-1.5h38a1.5 1.5 0 0 1 0 3h-38a1.5 1.5 0 0 1-1.5-1.5ZM11 28.438a1.5 1.5 0 0 1 1.5-1.5h38a1.5 1.5 0 0 1 0 3h-38a1.5 1.5 0 0 1-1.5-1.5Z"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M19.889 23.609c2.806-1.8 4.615-4.635 4.615-7.824 0-5.439-5.262-9.848-11.752-9.848C6.262 5.938 1 10.348 1 15.786c0 5.438 5.262 9.847 11.752 9.847a13.83 13.83 0 0 0 3.687-.494l3.253 3.12.197-4.65Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M12.752 6.813c-6.159 0-10.877 4.155-10.877 8.972 0 4.816 4.718 8.972 10.877 8.972 1.21 0 2.37-.163 3.454-.463l.48-.133 2.213 2.125.135-3.168.382-.246c2.604-1.67 4.213-4.25 4.213-7.087 0-4.817-4.719-8.973-10.877-8.973ZM.125 15.784c0-6.06 5.805-10.723 12.627-10.723 6.822 0 12.627 4.662 12.627 10.723 0 3.389-1.84 6.364-4.635 8.305l-.26 6.141-4.299-4.125a14.77 14.77 0 0 1-3.433.401C5.93 26.507.125 21.845.125 15.785Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M12 14.938a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0v-5ZM12 11.938a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
    />
  </svg>
);
export default SvgInformation;
